import React from 'react';
import { GetCart, GetTotal } from './CartHandler';
import { formatter } from '../../utils/common.js'
import { useState,useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASEURL;

function TotalsBlock (props) {
    const [cartTotal, setCartTotal] = useState(GetTotal());

    const [taxes, setTaxes] = useState(0);
    const headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + props.token.token
    };


    //BELOW Was a post method in the original project. I changed the post top get both this call and on the API.
    const getShippingTotal=()=>{
        try {
            axios.put(apiUrl + `/api/ShippingRate/GetUpsGroundRate`,JSON.stringify(GetCart()),{
                headers: headers

          })
              .then((response) => {
                // console.log("UPS GROUND RATE TOTALS BLOCK: ", response.data);
                  props.setShipping(response.data);
           
               })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
    }

    //below was a PUT in the original code. I changed this method to get in both the code and the API
    const getCartTax=()=>{
        try {
            axios.put(apiUrl + `/api/Items/GetCartTax`,JSON.stringify(GetCart()) ,{
                headers: headers
                // body: JSON.stringify(GetCart())
          })
              .then((response) => {
                // console.log("TotalsBlock GetCartTaxes Data: ", response.data);
               
                  setTaxes(response.data);
           
               })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
    }
    
    const setOrderTotal = () =>{
        props.setOrderTotal(cartTotal+props.shipping+taxes);
    }

    useEffect(() => {
        // console.log("Token on Totals Block",props.token);
        getShippingTotal();
        getCartTax();
        setOrderTotal();
    }, []);

    return (
        <aside id="checkout" className="block col-1 ">
            <h1>Total</h1>
            <div className="lg:flex-row flex-col ">
                <label>Subtotal</label>
                <label className='relative lg:left-[15rem]'>{formatter.format(cartTotal)}</label>
            </div>
            <div className="lg:flex-row flex-col ">
                <label>Discount</label>
                <label className='relative lg:left-[15rem]'>{"$0"}</label>
            </div>
            <div className="lg:flex-row flex-col">
                <label>Shipping</label>
                <label className='relative lg:left-[15rem]'>{formatter.format(props.shipping)}</label>
            </div>
            <div className="lg:flex-row flex-col">
                <label>Taxes</label>
                <label className='relative lg:left-[16.2rem]'>{formatter.format(taxes)}</label>
            </div>
            <hr />
            <div className="lg:flex-row flex-col">
                <label>Total</label>
                <label className='relative lg:left-[16.4rem]'>{formatter.format(cartTotal + props.shipping + taxes)}</label>
            </div>
        </aside>
    );



}
export default TotalsBlock;